import {defineChain} from "viem";

/**
 * Ritual Chain testnet. All RITUAL tokens are free testnet tokens with no
 * real-world value. Addresses/params reconfirmed against rpc.ritualfoundation.org.
 */
export const RITUAL_CHAIN_ID = 1979;

export const ritualChain = defineChain({
  id: RITUAL_CHAIN_ID,
  name: "Ritual",
  nativeCurrency: {name: "RITUAL", symbol: "RITUAL", decimals: 18},
  rpcUrls: {
    default: {
      http: [import.meta.env.VITE_RITUAL_RPC_URL ?? "https://rpc.ritualfoundation.org"],
      webSocket: [import.meta.env.VITE_RITUAL_WS_URL ?? "wss://rpc.ritualfoundation.org/ws"],
    },
  },
  blockExplorers: {
    default: {name: "Ritual Explorer", url: "https://explorer.ritualfoundation.org"},
  },
  testnet: true,
});

/** wallet_addEthereumChain params so the app can add Ritual testnet from the UI. */
export const addRitualChainParams = {
  chainId: "0x7BB", // 1979
  chainName: "Ritual",
  nativeCurrency: {name: "RITUAL", symbol: "RITUAL", decimals: 18},
  rpcUrls: ["https://rpc.ritualfoundation.org"],
  blockExplorerUrls: ["https://explorer.ritualfoundation.org"],
};

export function explorerTxUrl(hash: `0x${string}`): string {
  return `https://explorer.ritualfoundation.org/tx/${hash}`;
}

export function explorerAddressUrl(addr: `0x${string}`): string {
  return `https://explorer.ritualfoundation.org/address/${addr}`;
}
